import { useState, useEffect } from 'react';

export default function CallFAB() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(true);

  // Show after scrolling past the fold
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Stop pulse ring after 6 seconds so it doesn't get annoying
  useEffect(() => {
    const t = setTimeout(() => setPulse(false), 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      {/* Mobile only — hidden on md+ */}
      <div
        className={`md:hidden fixed bottom-6 right-5 z-50 transition-all duration-500 ease-out ${
          visible
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="Call us"
      >
        <div className="relative">
          {/* Pulse ring */}
          {pulse && (
            <span className="absolute inset-0 rounded-full bg-brand-yellow animate-ping opacity-30 pointer-events-none" />
          )}

          {/* Main pill */}
          <a
            href="tel:9102424567"
            className="whitespace-nowrap relative flex items-center gap-2.5 pl-3 pr-5 py-3 rounded-full bg-brand-yellow text-brand-blue-dark font-body font-bold text-sm cursor-pointer active:scale-95 transition-transform duration-150"
            style={{ boxShadow: '0 6px 24px -4px rgba(245,158,11,0.55)' }}
          >
            {/* Icon circle */}
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-blue-dark flex-shrink-0">
              <i className="ri-phone-fill text-brand-yellow text-base" />
            </div>
            <span>Call Us Now</span>
          </a>
        </div>

        {/* Hours micro-label */}
        <p className="font-body text-[10px] font-semibold text-gray-400 text-center mt-1.5 tracking-wide uppercase">
          Mon–Sat · 9am–9pm
        </p>
      </div>
    </>
  );
}
